import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

const ProgressBar = ({ percentage }) => (
    <Box sx={{ width: '100%', mt: 2 }}>
        <LinearProgress variant="determinate" value={percentage} />
        <Typography variant="body2" color="textSecondary" align="center">
            {percentage}%
        </Typography>
    </Box>
);

export default ProgressBar;
